import { render, staticRenderFns } from "./AddHolderData.vue?vue&type=template&id=c50a71be&"
import script from "./AddHolderData.vue?vue&type=script&lang=js&"
export * from "./AddHolderData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports